"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DriveTargetedTrafficWithGoogleAds() {
  const {
    ref: section1Ref,
    isVisible: section1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section2Ref,
    isVisible: section2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section3Ref,
    isVisible: section3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative overflow-hidden bg-light-background py-16 px-6 md:py-24">
      <div className="mx-auto max-w-7xl">
        {}
        <div className="mb-12 text-center">
          <h2 className="text-foreground-light font-display text-4xl font-bold md:text-5xl">
            Drive Targeted Traffic with Google Ads
          </h2>
          <p className="text-foreground-light/80 mx-auto mt-4 max-w-2xl text-lg">
            Reach your ideal customers with precision-targeted campaigns that
            deliver measurable results and maximize your ROI.
          </p>
        </div>

        {}
        <div className="relative mx-auto flex max-w-5xl items-center justify-center">
          {}
          <div ref={section1Ref} className="absolute left-0 top-8 z-10 transition-all duration-200 ease-[var(--ease-smooth)]" style={{
          opacity: section1Visible ? 1 : 0,
          transform: section1Visible ? "translateX(0)" : "translateX(-100px)"
        }}>
            <div className="group relative overflow-hidden rounded-xl shadow-[0_2px_4px_rgba(0,0,0,0.08),0_0_12px_hsl(45,95%,55%)] transition-all duration-200 hover:scale-[1.02] hover:shadow-medium">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/google_ads_campaign_dashboard.png" alt="Google Ads Campaign Dashboard" className="h-auto w-72 md:w-96" />
            </div>
          </div>

          {}
          <div ref={section2Ref} className="relative z-20 transition-all duration-200 ease-[var(--ease-smooth)]" style={{
          opacity: section2Visible ? 1 : 0,
          transform: section2Visible ? "translateX(0)" : "translateX(-100px)",
          transitionDelay: "100ms"
        }}>
            <div className="group relative overflow-hidden rounded-xl shadow-[0_2px_4px_rgba(0,0,0,0.08),0_0_12px_hsl(45,95%,55%)] transition-all duration-200 hover:scale-[1.02] hover:shadow-medium">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/search_ads_preview_mobile.png" alt="Search Ads Preview on Mobile" className="h-auto w-80 md:w-[28rem]" />
            </div>
          </div>

          {}
          <div ref={section3Ref} className="absolute right-0 top-8 z-30 transition-all duration-200 ease-[var(--ease-smooth)]" style={{
          opacity: section3Visible ? 1 : 0,
          transform: section3Visible ? "translateX(0)" : "translateX(-100px)",
          transitionDelay: "200ms"
        }}>
            <div className="group relative overflow-hidden rounded-xl shadow-[0_2px_4px_rgba(0,0,0,0.08),0_0_12px_hsl(45,95%,55%)] transition-all duration-200 hover:scale-[1.02] hover:shadow-medium">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/display_ads_performance_chart.png" alt="Display Ads Performance Chart" className="h-auto w-72 md:w-96" />
            </div>
          </div>
        </div>

        {}
        <div className="h-64 md:h-96"></div>
      </div>
    </section>;
}